/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateAwsKmsKeyForm,
  CreateAwsKmsKeyForm$Outbound,
  CreateAwsKmsKeyForm$outboundSchema,
} from "../components/createawskmskeyform.js";

export type CreateAwsKmsKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type CreateAwsKmsKeyRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  createAwsKmsKeyForm: CreateAwsKmsKeyForm;
};

/** @internal */
export type CreateAwsKmsKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const CreateAwsKmsKeySecurity$outboundSchema: z.ZodMiniType<
  CreateAwsKmsKeySecurity$Outbound,
  CreateAwsKmsKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createAwsKmsKeySecurityToJSON(
  createAwsKmsKeySecurity: CreateAwsKmsKeySecurity,
): string {
  return JSON.stringify(
    CreateAwsKmsKeySecurity$outboundSchema.parse(createAwsKmsKeySecurity),
  );
}

/** @internal */
export type CreateAwsKmsKeyRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  CreateAwsKmsKeyForm: CreateAwsKmsKeyForm$Outbound;
};

/** @internal */
export const CreateAwsKmsKeyRequest$outboundSchema: z.ZodMiniType<
  CreateAwsKmsKeyRequest$Outbound,
  CreateAwsKmsKeyRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    createAwsKmsKeyForm: CreateAwsKmsKeyForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      createAwsKmsKeyForm: "CreateAwsKmsKeyForm",
    });
  }),
);

export function createAwsKmsKeyRequestToJSON(
  createAwsKmsKeyRequest: CreateAwsKmsKeyRequest,
): string {
  return JSON.stringify(
    CreateAwsKmsKeyRequest$outboundSchema.parse(createAwsKmsKeyRequest),
  );
}
